import { useEffect, useState } from 'react';

import Button from '../Button/Button';
import { supabase } from '../../../api';

import { Grid, Typography, Avatar, Paper, Box, Chip } from '@mui/material';
import { useParams } from 'react-router-dom';
import { PROFILE_PUBLIC_TABLE } from '../../../constants/supabase_constants';

const ProfilePage = (props) => {
  let [user, setUser] = useState({});
  let { id } = useParams();

  useEffect(() => {
    getUser();
    // eslint-disable-next-line
  }, []);

  const getUser = async () => {
    const { data: user, error } = await supabase.from(PROFILE_PUBLIC_TABLE).select('*').eq('id', id).single();
    if (error) console.log(error);
    else {
      setUser(user);
      console.log(user);
    }
  };

  if (user === undefined) {
    return <Typography>Still loading...</Typography>;
  }

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mt: '4rem',
        mx: 'auto',
        textAlign: 'center',
      }}>
      <Avatar
        src={
          user.avatar_url
            ? `https://hnjiwdxlyyttjbocwpfw.supabase.co/storage/v1/object/public/avatars/${user.avatar_url}`
            : 'https://picsum.photos/200'
        }
        alt={user.avatar_url ? 'Avatar' : 'No image'}
        sx={{
          width: 150,
          height: 150,
          mx: 'auto',
          border: '4px solid #F6F6F6',
        }}
      />
      <Typography variant='h3' component='h1' sx={{ fontWeight: 'bold', mt: '2rem' }}>
        {user.fullName}
      </Typography>
      <Typography variant='h5' sx={{ mt: '0.5rem' }}>
        {user.title}
      </Typography>
      <Box sx={{ my: '2rem', display: 'flex', mx: 'auto' }}>
        <Button text={`Find ${user.fullName} on LinkedIn`} link={user.linkedin} />
      </Box>
      <Paper elevation={20} sx={{ padding: '2rem', mt: '5rem', textAlign: 'left' }}>
        <Typography variant='h6' component='h3' sx={{ fontWeight: 'bold' }}>
          About {user.fullName}
        </Typography>
        <Typography variant='body1'>{user.about}</Typography>
        <Typography variant='h6' component='h3' sx={{ fontWeight: 'bold', mt: '2rem' }}>
          Skills
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          {user.skills && user.skills.map((value) => <Chip key={value} label={value} />)}
        </Box>
      </Paper>
      <Paper elevation={20} sx={{ padding: '2rem', mt: '3rem', textAlign: 'left' }}>
        <Typography variant='h6' component='h3' sx={{ fontWeight: 'bold' }}>
          About {user.companyName}
        </Typography>
        <Typography variant='body1'>{user.companyAbout}</Typography>
        <Typography variant='h6' component='h3' sx={{ fontWeight: 'bold', mt: '2rem' }}>
          Company Link
        </Typography>
        <a href={user.companyLink} target='_blank' rel='noreferrer'>
          <Typography variant='body1' sx={{ color: 'primary.main' }}>
            {user.companyLink}
          </Typography>
        </a>
      </Paper>
      <Paper elevation={20} sx={{ padding: '2rem', mt: '3rem', textAlign: 'left' }}>
        <Typography variant='h6' component='h3' sx={{ fontWeight: 'bold' }}>
          Contact
        </Typography>
        <Typography variant='body1'>
          Email: {user.email}
          <br></br>
        </Typography>
      </Paper>
    </Grid>
  );
};

export default ProfilePage;
